// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';

export class DispatchCustomerSummaryConnectionDetails {
  readonly isConnectedToCompany: boolean;
  readonly isAutoLinked: boolean | null;
  readonly createdByName: string | null;
  readonly createdById: string | null;
  readonly createdAt: DateTime | null;

  constructor(data: { [key: string]: any } = {}) {
    this.isConnectedToCompany =
      data.isConnectedToCompany === undefined ? false : data.isConnectedToCompany;
    this.isAutoLinked = data.isAutoLinked === undefined ? null : data.isAutoLinked;
    this.createdByName = data.createdByName === undefined ? null : data.createdByName;
    this.createdById = data.createdById === undefined ? null : data.createdById;
    this.createdAt = DateHelpers.ParseServerNullableDate(data.createdAt);
  }

  static zero(): DispatchCustomerSummaryConnectionDetails {
    const zeroValues: ExcludeMethodsDeep<DispatchCustomerSummaryConnectionDetails> = {
      isConnectedToCompany: false,
      isAutoLinked: null,
      createdByName: null,
      createdById: null,
      createdAt: null,
    };
    return new DispatchCustomerSummaryConnectionDetails(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DispatchCustomerSummaryConnectionDetailsWireFormat = {
  isConnectedToCompany: boolean;
  isAutoLinked: boolean | null;
  createdByName: string | null;
  createdById: string | null;
  createdAt: string | null;
};

type NewDispatchCustomerSummaryConnectionDetailsProps = PartialDeep<
  DispatchCustomerSummaryConnectionDetails,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerSummaryConnectionDetails: (
  props: NewDispatchCustomerSummaryConnectionDetailsProps,
) => DispatchCustomerSummaryConnectionDetails = (props) =>
  new DispatchCustomerSummaryConnectionDetails(props);

type NewDispatchCustomerSummaryConnectionDetailsFromWireFormatProps = PartialDeep<
  DispatchCustomerSummaryConnectionDetailsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerSummaryConnectionDetailsFromWireFormat: (
  props: NewDispatchCustomerSummaryConnectionDetailsFromWireFormatProps,
) => DispatchCustomerSummaryConnectionDetails = (props) =>
  new DispatchCustomerSummaryConnectionDetails(props);
